import { create } from 'zustand';

export const useOffersFiltersStore = create((set, get) => ({
  filters: {},

  setFilters: (newFilters) => set({ filters: newFilters }),

  updateFilters: (partialFilters) =>
    set({ filters: { ...get().filters, ...partialFilters } }),

  setFilter: (key, value) =>
    set({ filters: { ...get().filters, [key]: value } }),

  removeFilter: (key) => {
    const { [key]: _, ...remainingFilters } = get().filters;
    set({ filters: remainingFilters });
  },

  clearFilters: () => set({ filters: {} }),

  getFilters: () => get().filters,

  getFilter: (key) => get().filters[key],

  hasFilters: () => Object.keys(get().filters).length > 0,

  hasFilter: (key) => key in get().filters,
}));
